










































































import handleError, { getAuthErrorNotification } from "@/helpers/errors";
import { useNotifier } from "@/providers/notifier";
import { auth, providers } from "@/services/firebase";
import { defineComponent, reactive } from "@vue/composition-api";

export default defineComponent({
  name: "LoginForm",
  setup() {
    const notify = useNotifier();

    const vm = reactive({
      email: "",
      loading: false,
      password: "",
    });

    async function signInUsingEmail() {
      vm.loading = true;

      try {
        await auth.signInWithEmailAndPassword(vm.email, vm.password);
      }
      catch (e) {
        handleError(e);
        notify(getAuthErrorNotification(e.code));
      }

      vm.loading = false;
    }

    async function signInUsingFacebook() {
      try {
        const provider = new providers.FacebookAuthProvider();
        await auth.signInWithPopup(provider);
      }
      catch (e) {
        handleError(e);
        notify(getAuthErrorNotification(e.code));
      }
    }

    async function signInUsingGoogle() {
      try {
        const provider = new providers.GoogleAuthProvider();
        await auth.signInWithPopup(provider);
      }
      catch (e) {
        handleError(e);
        notify(getAuthErrorNotification(e.code));
      }
    }

    return {
      signInUsingEmail,
      signInUsingFacebook,
      signInUsingGoogle,
      vm
    };
  },
});
